export default "__VITE_ASSET__vLElBviQ__"